import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import Accordions from './Accordions/Accordions'
import CardsList from './CardsList/CardsList'
import CallToActionBlock from './CallToActionBlock/CallToActionBlock'
import Hero from './Hero/Hero'
import ImageTextBlocks from './ImageTextBlocks/ImageTextBlocks'
import LogosGrid from './LogosGrid/LogosGrid'
import Media from './Media/Media'
import Newsletter from './Newsletter/Newsletter'
import Quote from './Quote/Quote'
import Registration from './Registration/Registration'

import authProvider from '../../utils/auth-provider'

export default function Landing (props = {
    data: null
}) {
    if (!Array.isArray(props.data)
            || !props.data.length)
        return null

    const components = {
        Accordions,
        CardsList,
        CallToActionBlock,
        Hero,
        ImageTextBlocks,
        LogosGrid,
        Media,
        Newsletter,
        Quote,
        Registration
    }

    const isUser = Boolean((authProvider.getIdentity() || {}).id)

    const isAdmin = authProvider.getDefaultRole() === 'admin'

    const isMember = authProvider.getDefaultRole() === 'member'

    const history = useHistory()

    useEffect(() => {
        if (history.location.pathname !== '/advanced-membership'
                || isMember
                || isAdmin
                || !isUser)
            return

        history.replace('/')
    }, [])

    return props.data
        .filter(obj => obj.type
            && components[obj.type])
        .map((obj, idx) => {
            const Component = components[obj.type]
            return <Component key={`landing-${idx}`} {...obj} />
        })
}
